<template>
  <div class="dialog-wrap" :class="{'load-top':isLoadTop}">
    <div class="dialog-cover"  v-if="isShow" @click="closeMyself"></div>
    <transition name="drop">
      <div class="dialog-content"  v-if="isShow">
        <!-- <p class="dialog-close" @click="closeMyself">x</p> -->
        <slot></slot>
      </div>
    </transition>
  </div>
</template>
<script type="text/javascript">
  export default {
    props: {
      isShow: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        isLoadTop: false
      };
    },
    watch: {
      isShow() {
        if(this.isShow) {
          this.isLoadTop = true
        }else {
          setTimeout(() => {
            this.isLoadTop = false
          },500)
        }
      }
    },
    methods: {
      closeMyself () {
        this.$emit('on-close');
      }
    }
  };
</script>
<style scoped>
  .drop-enter-active {
    transition: all .5s ease;
  }
  .drop-leave-active {
    transition: all .3s ease;
  }
  .drop-enter {
    transform: translateY(-600px);
  }
  .drop-leave-active {
    transform: translateY(-600px);
  }

  .dialog-wrap {
    position: fixed;
    width: 100%;
    height: 100%;
  }
  .load-top {
    z-index: 1200;
  }
  .dialog-cover {
    opacity: .3;
    position: fixed;
    z-index: 5;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .dialog-content {
    position: fixed;
    top: 20%;
    left: 50%;
    z-index: 1000;
    margin-left: -600px;
    background: #fff;
    border-radius: 20px;
  }
  .dialog-close {
    position: absolute;
    right: 5px;
    top: 5px;
    width: 20px;
    height: 20px;
    text-align: center;
    cursor: pointer;
  }
  .dialog-close:hover {
    color: #4fc08d;
  }
</style>


// WEBPACK FOOTER //
// src/base/resetDialog.vue